import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icons } from './Icons';

// Insight rows arrive with `answer` as either the numeric code the backend
// stores (1/2/3) or the string label some endpoints return (PASS/FAIL/N/A).
// Both shapes need to reduce to the same three-bucket total.
export const deriveInsightCounts = (rows) => {
	const list = Array.isArray(rows) ? rows : [];
	const c = { pass: 0, fail: 0, na: 0 };
	list.forEach((r) => {
		if (r?.answer === 1 || r?.answer === 'PASS') c.pass++;
		else if (r?.answer === 2 || r?.answer === 'FAIL') c.fail++;
		else if (r?.answer === 3 || r?.answer === 'N/A') c.na++;
	});
	return { ...c, total: list.length };
};

const PayloadInsightsCard = ({ sectionId = 'insights', counts, detailsHref }) => {
	const { t } = useTranslation();

	const safeCounts = counts ?? { pass: 0, fail: 0, na: 0, total: 0 };
	const total = safeCounts.total || (safeCounts.pass + safeCounts.fail + safeCounts.na);
	const widthPct = (n) => (total > 0 ? (n / total) * 100 : 0);

	return (
		<section id={sectionId} className='pn-card'>
			<div className='pn-section-header'>
				<h2 className='pn-section-title'>
					<Icons.bulb /> {t('payload.payloadInsights.title')}
				</h2>
				{detailsHref && (
					<a href={detailsHref} className='pn-btn-ghost' style={{ textDecoration: 'none' }}>
						{t('payload.payloadInsights.viewDetails')} <Icons.arrow />
					</a>
				)}
			</div>
			<div className='pn-insights-line'>
				<div>
					<span className='pn-insights-pass'>{safeCounts.pass}</span>{' '}
					<span className='pn-insights-text'>
						{t('payload.payloadInsights.ledeRest', { evaluated: safeCounts.pass + safeCounts.fail })}
					</span>
				</div>
				<div className='pn-insights-meta'>
					{safeCounts.fail} need attention · {safeCounts.na} N/A
				</div>
			</div>
			<div className='pn-insights-bar'>
				<span className='pass' style={{ width: `${widthPct(safeCounts.pass)}%` }} />
				<span className='fail' style={{ width: `${widthPct(safeCounts.fail)}%` }} />
				<span className='na' style={{ width: `${widthPct(safeCounts.na)}%` }} />
			</div>
			<div className='pn-insights-legend'>
				<span>
					<span className='pn-insights-swatch' style={{ background: 'var(--ds-pass)' }} />
					{safeCounts.pass} {t('payload.payloadInsights.keystats.pass')}
				</span>
				<span>
					<span className='pn-insights-swatch' style={{ background: 'var(--ds-fail)' }} />
					{safeCounts.fail} {t('payload.payloadInsights.keystats.fail')}
				</span>
				<span>
					<span className='pn-insights-swatch' style={{ background: 'var(--ds-na)' }} />
					{safeCounts.na} {t('payload.payloadInsights.keystats.na')}
				</span>
			</div>
		</section>
	);
};

export default PayloadInsightsCard;
